/**
 * OTA updater handshake (native shell only).
 *
 * The Capgo updater (`@capgo/capacitor-updater`, configured in
 * apps/mobile/capacitor.config.ts) swaps in a downloaded web bundle on app
 * start and ROLLS BACK to the previous bundle unless the new one confirms it
 * booted within `appReadyTimeout` (10s default). `notifyAppReady()` is that
 * confirmation — it must run once per launch, early after mount. This is the
 * safety net that makes a broken OTA deploy self-heal instead of bricking the
 * installed app.
 *
 * No-op in the browser and in shells that predate the updater plugin.
 */
import { isNativeShell } from './platform';

export async function initNativeUpdater(): Promise<void> {
  if (!isNativeShell()) return;

  try {
    const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
    await CapacitorUpdater.notifyAppReady();
  } catch {
    // Plugin unavailable (older shell) — nothing to confirm, nothing to roll back.
  }
}
